/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author HyeongJin O
 * @contact hjoh@detech.co.kr
 * @date 2022-11-11
 * @brief EHP 진단점검 Report - 진단점검 Report 결과 초기 개발
 *
 ********************************************************************/
import React from "react";
//utils
import clog from "../../../utils/logUtils";
/**
 * @brief EHP 진단점검 Report 결과 초기화면 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function NoItemCheckHistory(props) {
    const isOpen = (props.hasOwnProperty("isOpen")) ? props.isOpen : false;
    const setParentResultOpen = props.setResultOpen;
    function handleResultOpen(e, openVal) {
        clog("IN ITEMCHECKRESULT : handleResultOpen : " + openVal);
        setParentResultOpen(!openVal);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("article", { className: `box ehc__score  ehc-b ${(isOpen) ? "" : "close"}` },
            React.createElement("div", { className: "box__header" },
                React.createElement("p", { className: "box__title" },
                    React.createElement("button", { type: "button", className: "btn btn-box ", onClick: (e) => handleResultOpen(e, isOpen) },
                        React.createElement("span", { className: "hide" }, "\uBA54\uB274\uC811\uAE30\uD3BC\uCE58\uAE30")),
                    React.createElement("span", { className: "cate" },
                        "Basic ",
                        React.createElement("span", null, "e-HC")))),
            React.createElement("div", { className: "box__body" },
                React.createElement("p", { className: "txt-ready" },
                    React.createElement("span", null,
                        React.createElement("strong", null, "\uC9C4\uB2E8\uC810\uAC80 \uB9AC\uD3EC\uD2B8"),
                        " \uC5D0\uC11C \uC810\uAC80\uACB0\uACFC \uBCF4\uAE30 \uBC84\uD2BC\uB97C \uBA3C\uC800 \uC120\uD0DD\uD574\uC8FC\uC138\uC694."))))));
}
export default NoItemCheckHistory;
